import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import anime from "animejs/lib/anime.es.js";

@Component({
  selector: 'app-animated-number',
  templateUrl: './animated-number.component.html',
  styleUrls: ['./animated-number.component.scss']
})
export class AnimatedNumberComponent implements OnChanges, OnDestroy {
  @Input() value?: number;
  @Input() class?: string;
  @Input() unit?: string;
  @Input() round?: number = 1;

  current: { value: number } = {
    value: 0
  }

  private animation?: ReturnType<typeof anime>;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    this.animate();
  }

  ngOnDestroy() {
    this.animation?.pause();
  }

  animate() {
    this.animation?.pause();
    this.animation = anime({
      targets: this.current,
      value: this.value,
      easing: "easeOutCubic",
      round: this.round,
      duration: 1000,
      delay: 100,
      // anime.js shares one frame loop between all its animations: a frame started outside the Angular
      // zone never triggers change detection, and the number froze on an intermediate value.
      update: () => this.cdr.detectChanges(),
    });
  }
}
